export default "__VITE_ASSET__bab1a407__"